import { createSelector } from 'reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

const isShowConflictsOnlyFilterSelectedSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => facilityViewState.isShowConflictsOnlyFilterSelected,
);

export default isShowConflictsOnlyFilterSelectedSelector;
